// extracted by mini-css-extract-plugin
export var childrenContainer = "_3g-0";